// src/components/MaterialReceiptTrend.js
import React, { useState } from "react";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import GroupedCategories from "highcharts-grouped-categories";

import { Box, Grid2, MenuItem, Select, Typography, useTheme } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import { fontSize, fontWeight, style } from "@mui/system";
import { ReactComponent as ChevronDownIcon } from "assets/PwC_Funct_Icons_ChevronDown_Outline_Black_RGB.svg"
GroupedCategories(Highcharts);

const MaterialReceiptTrend = () => {
  const theme = useTheme();
  const [selectedCategory, setSelectedCategory] = useState("All");

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const chartOptions = {
    chart: {
      height: 430,
      spacingTop: 10,
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [
        {
          name: "July 2024",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
        {
          name: "August 2024",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
        {
          name: "September 2024",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
        {
          name: "October 2024",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
        {
          name: "November 2024",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
        {
          name: "December 2024",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
        {
          name: "January 2025",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
        {
          name: "February 2025",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
        {
          name: "March 2025",
          categories: [{ name: "Cum" }, { name: "MT" }, { name: "RM" }],
        },
      ],
      labels: {
        useHTML: true,
        groupedOptions: [
          {
            style: {
              color: "#414D55",
              fontWeight: 500,
              fontSize: "14px",
              whiteSpace: "nowrap",
            },
            y: 20,
          },
        ],
        style: {
          color: "#00000080",
          fontSize: "14px",
          fontWeight: 500,
          color: "#464646B2"
        },
      },

      gridLineWidth: 0,
      lineWidth: 1,
      tickWidth: 0,
      ticklength: 1,
      tickColor: "#758195",
      lineColor: "#758195",
      tickmarkPlacement: "off",
      borderWidth: 0,
      min: 0,
      max: 8,
      scrollbar: {
        enabled: true,
      },
    },
    yAxis: {
      // tickPositioner: function () {
      //   let positions = [10];
      //   for (let i = 600; i <= 5400; i += 600) {
      //     positions.push(i);
      //   }
      //   return positions;
      // },

      title: {
        text: "UOM",
        style: {
          color: "#415385",
          fontWeighT: 500,
          fontSize: "14px"

        }
      },
      allowDecimals: false,
      min: 0,
      gridLineWidth: 1,
      lineWidth: 1,
      tickWidth: 1,
      tickColor: "#758195",
      lineColor: "#758195",
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      headerFormat: "<b>{point.key}</b><br/>",
      pointFormat: "{series.name}: {point.y}<br/>",
    },
    plotOptions: {
      column: {
        shadow: false,
        borderWidth: 0,
        groupPadding: 0.1,
        dataLabels: {
          enabled: true,
          style: {
            textOutline: "none",
            fontSize: "12px",
            fontWeight: 500,
            color: "#464646",
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        type: "column",
        name: "Actual",
        data: [1485, 527, 4709, 1200, 455, 4948, 1335, 585, 4781, 1159, 460, 3622, 1198, 547, 3655, 1428, 474, 4530, 1282, 554, 3970, 1253, 537, 4220, 1411, 470, 4858],
        color: "#415385",
      },
      {
        type: "column",
        name: "Plan",
        data: [1403, 506, 4287, 1113, 448, 4906, 1248, 447, 4206, 1043, 460, 2734, 959, 477, 2717, 1162, 398, 3574, 989, 429, 3755, 1049, 474, 3941, 1340, 346, 4281],
        color: "#CE412D",
      },
    ],
  };

   const CustomChevronIcon = (props) => (
              <ChevronDownIcon style={{ width: '16px', height: '16px' }} {...props} />
          );
  

  return (
    <Box
      sx={{
        padding: 2,
        background: "#fff",
        borderRadius: 2,
        height: "100%",
        border: "1px solid #2525252E",
      }}
    >
      <Grid2 container>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Typography
            variant="body"
            sx={{
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "100%",
              letterSpacing: "-0.4px",
              color: `${theme?.customSettings?.themeColor}`,
            }}
          >
            Material Receipt Trend
          </Typography>
          {/* <Typography
            sx={{
              mt: "5px",
              color: "#5052588A",
              fontSize: "14px",
              mb: "20px",
              lineHeight: "100%",
              letterSpacing: "-0.4px",
            }}
          >
            Get a holistic view of how work is being prioritized
          </Typography> */}
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }} sx={{ mt: { xs: 1.5, md: 0 } }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: { xs: 'center', md: 'end' },
              mt: "0",
            }}
          >
            <Select
              value={selectedCategory}
              onChange={handleCategoryChange}
              // IconComponent={IoIosArrowDown}
              IconComponent={CustomChevronIcon}
              sx={{
                marginLeft: "30px",
                backgroundColor: "#E8E8E8",
                color: "#474747",
                boxShadow: "none",
                "& .MuiOutlinedInput-input": { padding: "5px 15px" },
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              }}
            >
              <MenuItem value={"All"}>All</MenuItem>
            </Select>
          </Box>
        </Grid2>
      </Grid2>

      <Grid2 size={{ xs: 12, md: 12 }}>
        <Box sx={{ mt: "40px" }}>
          <HighchartsReact highcharts={Highcharts} constructorType={"chart"} options={chartOptions} />
        </Box>
      </Grid2>
    </Box>
  );
};

export default MaterialReceiptTrend;
